import { render, staticRenderFns } from "./SendPromoCode.vue?vue&type=template&id=710f2803&scoped=true&"
import script from "./SendPromoCode.vue?vue&type=script&lang=js&"
export * from "./SendPromoCode.vue?vue&type=script&lang=js&"
import style0 from "./SendPromoCode.vue?vue&type=style&index=0&id=710f2803&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f2803",
  null
  
)

export default component.exports